module.exports = __webpack_public_path__ + "static/media/hydration_mask.7f72d849.png";